import { render, staticRenderFns } from "./DiagnosisDialog.vue?vue&type=template&id=f576718e&scoped=true"
import script from "./DiagnosisDialog.vue?vue&type=script&lang=js"
export * from "./DiagnosisDialog.vue?vue&type=script&lang=js"
import style0 from "./DiagnosisDialog.vue?vue&type=style&index=0&id=f576718e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f576718e",
  null
  
)

export default component.exports